import { memo } from 'react';

import { FileProgress } from './FileProgress.tsx';
import { FileStateIcon } from './FileStateIcon.tsx';
import { FileStateContainer } from './styled.ts';
import type { FileResetHandler } from './types.ts';

export const FileState = memo(function FileState({
  error,
  isUploading,
  onReset,
  progress,
  success,
  tryAnotherText,
}: {
  error?: string;
  isUploading: boolean;
  onReset?: FileResetHandler;
  progress?: number;
  success: boolean;
  tryAnotherText: string;
}) {
  if (!isUploading && !success && !error) {
    return null;
  }

  const progressVisible = !!(progress && progress !== -1);

  return (
    <FileStateContainer>
      {progressVisible && !error && <FileProgress progress={progress} />}
      <FileStateIcon
        error={error}
        isUploading={isUploading}
        onReset={onReset}
        progressVisible={progressVisible}
        success={success}
        tryAnotherText={tryAnotherText}
      />
    </FileStateContainer>
  );
});
